// ── A CALENDAR date, rendered as sent ──────────────────────────────────────────────────────────
//
// ⚠ A 'YYYY-MM-DD' string from the server is a DAY in the tenant's calendar, not an instant. Parsing it
//   with `new Date('2026-03-12')` makes it midnight UTC, and a browser west of UTC then shows 11 March.
//   So it is split and named, never parsed: the day the server resolved is the day the reader sees.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** '2026-03-12' → '12 Mar 2026'. null (or anything that is not a calendar date) → null. */
export function formatCalendarDate(day: string | null | undefined): string | null {
  if (!day) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (!m) return null;
  const month = MONTHS[Number(m[2]) - 1];
  if (!month) return null;
  return `${Number(m[3])} ${month} ${m[1]}`;
}
